import script from "./Drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./Drawer.vue?vue&type=script&lang=ts&setup=true"

import "./Drawer.vue?vue&type=style&index=0&id=3111f0ad&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3111f0ad"]])

export default __exports__